import React from "react";

const ProgramModulesAIR = () => {
  const sections = [
    {
      heading: "Prerequisite",
      title:
        "Postgraduate Certificate in The Young Emerging Politician Programme (30 ECTS)",
      description:
        "Students must complete the Postgraduate Certificate, which includes foundational modules such as:",
      modules: [
        "Foundations of Politics",
        "Comparative Political Systems",
        "Cultural Relations and Diplomacy",
        "Promoting Inclusivity and Sustainable Governance",
      ],
      footer:
        "This foundation prepares students for the advanced modules in the Postgraduate Diploma.",
    },
    {
      heading: "Compulsory Modules",
      title:
        "Postgraduate Diploma in Advanced International Relations & Diplomatic Practice (30 ECTS)",
      description:
        "Offers intermediate expertise in diplomacy, international relations, and conflict resolution.",
      modules: [
        "International Organisations (3 ECTS): Analyse the roles and structures of international organisations in promoting global governance and cooperation.",
        "Foreign Policy Analysis and Implementation (3 ECTS): Examine the development and execution of foreign policies in complex geopolitical environments.",
        "Science Diplomacy: Innovation and Global Impact (3 ECTS): Explore the role of science and technology in fostering international collaboration and addressing global challenges.",
        "International Security and Diplomacy (3 ECTS): Investigate key security concerns, including terrorism, cyber warfare, and disarmament, and their implications for diplomacy and international relations.",
        "Environment and Sustainability (3 ECTS): Examine the role of diplomacy in promoting sustainable development and addressing global environmental challenges like biodiversity loss and resource management.",
        "Modes of Diplomacy in the 21st Century (3 ECTS): Examine modern diplomatic practices, including public, economic, and cultural diplomacy.",
        "Diplomatic Negotiation Techniques (3 ECTS): Learn strategies for effective negotiation and consensus-building in international settings.",
        "Trends and Transformations in World Politics (3 ECTS): Analyse political trends and their impact on global diplomacy and governance.",
        "Foreign Office Leadership (3 ECTS): Develop leadership and strategic decision-making skills tailored for senior officials in foreign offices, focusing on diplomacy, policy implementation, and governance.",
        "Advanced Conflict Management and Mediation (3 ECTS): Focus on advanced tools and methods for resolving international disputes, with emphasis on post-conflict rebuilding and sustainable outcomes.",
      ],
    },
  ];

  return (
    <section id="program-modules-air" className="p-6 md:mt-10 bg-gray-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
          Programme Modules
        </h2>

        {sections.map((section, idx) => (
          <div key={idx} className="mb-10">
            <h3 className="text-2xl font-semibold text-indigo-700 mb-4">
              {section.heading}
            </h3>
            <div className="bg-sdbodywhiteywhitebodyywhitebodyywhitebodyywhitebody border-l-4 border-indigo-500 p-6 shadow-md">
              <h4 className="text-xl font-bold mb-3">{section.title}</h4>
              <p className="mb-4 text-gray-700">{section.description}</p>
              {section.heading === "Prerequisite" ? (
                <ul className="list-disc pl-6 mb-4 text-gray-700">
                  {section.modules.map((module, index) => (
                    <li key={index}>{module}</li>
                  ))}
                </ul>
              ) : (
                <ol className="list-decimal pl-6 text-gray-700 space-y-3">
                  {section.modules.map((module, index) => (
                    <li key={index}>{module}</li>
                  ))}
                </ol>
              )}
              {section.footer && (
                <p className="mt-4 text-gray-600">{section.footer}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProgramModulesAIR;
